module.exports = __webpack_public_path__ + "img/19.e217911d.jpg";